import { axiosInstance } from '../hooks/useAxios'

export const sendToErrorLog = async (error: any) => {
  try {
    await axiosInstance.post('/report/errors', { query: error })
  } catch (err) {
    console.error('Failed to send error log:', err)
  }
}

export const sendToErrorLogUnAuth = async (error: any) => {
  try {
    await axiosInstance.post('/report/errors/message', { query: error })
  } catch (err) {
    console.error('Failed to send error log:', err)
  }
}
